export const BannerVariant = {
    DANGER: 'danger',
    ALERT: 'alert'
}